/**
 * 规则数据模型（设计文档 3.5 / F-008），zod 定义为单一事实来源。
 *
 * Rule = { name, priority, conditions: Predicate[], action: Action }
 * conditions 之间为 AND；按 priority 升序匹配，首命中生效。
 */
import { z } from 'zod';

export const PredicateFieldSchema = z.enum(['call.waitMs', 'call.direction', 'call.floor']);
export type PredicateField = z.infer<typeof PredicateFieldSchema>;

export const PredicateOpSchema = z.enum(['>', '<', '>=', '<=', '==', 'in']);
export type PredicateOp = z.infer<typeof PredicateOpSchema>;

export const PredicateSchema = z.object({
  field: PredicateFieldSchema,
  op: PredicateOpSchema,
  // number（比较）、'up'|'down'（方向）、number[]（floor in 集合）
  value: z.union([z.number(), z.string(), z.array(z.number())]),
});
export type Predicate = z.infer<typeof PredicateSchema>;

export const ActionTypeSchema = z.enum(['assign-nearest', 'assign-min-eta']);
export type ActionType = z.infer<typeof ActionTypeSchema>;

export const ActionSchema = z.object({
  type: ActionTypeSchema,
});
export type Action = z.infer<typeof ActionSchema>;

export const RuleSchema = z.object({
  name: z.string().min(1),
  priority: z.number().int(),
  conditions: z.array(PredicateSchema).min(1, '至少 1 个条件'),
  action: ActionSchema,
});
export type Rule = z.infer<typeof RuleSchema>;

export const RuleSetSchema = z.object({
  rules: z.array(RuleSchema),
});
export type RuleSet = z.infer<typeof RuleSetSchema>;
